import React from 'react';
import { PlusCircleIcon, BookOpenIcon, TicketIcon, ActivityIcon } from 'lucide-react';
interface QuickActionsProps {
  onNavigate: (view: string) => void;
}
export function QuickActions({
  onNavigate
}: QuickActionsProps) {
  const actions = [{
    id: 'submit-ticket',
    title: 'Submit a New Ticket',
    description: 'Report an issue or request new hardware/software.',
    icon: PlusCircleIcon,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    hoverBorder: 'hover:border-blue-300'
  }, {
    id: 'knowledge-base',
    title: 'Browse Knowledge Base',
    description: 'Find guides, FAQs, and troubleshooting steps.',
    icon: BookOpenIcon,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    hoverBorder: 'hover:border-indigo-300'
  }, {
    id: 'my-tickets',
    title: 'View My Tickets',
    description: 'Check the status of your open support requests.',
    icon: TicketIcon,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    hoverBorder: 'hover:border-purple-300'
  }, {
    id: 'status',
    title: 'Check System Status',
    description: 'View current uptime for Salesforce, Encompass, etc.',
    icon: ActivityIcon,
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    hoverBorder: 'hover:border-green-300',
    onClick: () => alert('All systems operational. (Mock Action)')
  }];
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-136">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-137">
        {actions.map(action => {
        const Icon = action.icon;
        return <button key={action.id} onClick={action.onClick ? action.onClick : () => onNavigate(action.id)} className={`flex flex-col items-start p-6 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-all text-left ${action.hoverBorder} group`} data-id="element-138">
              <div className={`p-3 rounded-xl ${action.bgColor} ${action.color} mb-4 group-hover:scale-110 transition-transform`} data-id="element-139">
                <Icon className="w-6 h-6" data-id="element-140" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-141">
                {action.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed" data-id="element-142">
                {action.description}
              </p>
            </button>;
      })}
      </div>
    </div>;
}